<template>
    <div
        :style="styles"
        class="flex items-center font-medium min-w-0 gap-2"
    >
        <RedesignBaseIcon
            :name="timeFrameIcon"
            :size="24"
            class="shrink-0"
        />
        <span class="truncate">{{ dateInterval }}</span>
    </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import RedesignBaseIcon from '@/components/RedesignBaseComponents/RedesignBaseIcon.vue'
import { getWidgetDateInterval } from '@/helpers/widgetUtils'
import { activeLayoutFontSize } from '@/composables/globalData/useLayouts'
import type { WidgetExtended } from '@/types/dashboard'

const props = defineProps<{
    widget: WidgetExtended
}>()

const styles = computed(() => activeLayoutFontSize.value)

const dateInterval = computed(() => getWidgetDateInterval(props.widget))

const timeFrameIcon = computed(() => {
    switch (props.widget.WidgetTime?.type) {
        case 'absolute':
            return 'CalendarRange'
        case 'period':
            return 'CalendarClock'
        default:
            return 'Calendar'
    }
})
</script>
